import React, { useState, useEffect } from "react";
import Loader from "../../Components/Common/Loader";
import { Col, Row, Card, CardHeader, CardBody, Button, Dropdown, DropdownItem, DropdownMenu, ButtonGroup, Input, Label, DropdownToggle, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import {
  getLocalStorageData, displayDateV1, convertDateFormate, getDateByName, getPercentageWithAlertV1,
  currencyFormatWithoutDecimalV1
} from "../../helpers/api_helper";
import ReactApexChart from "react-apexcharts";
import "../../assets/scss/config/default/HeatmapTable.scss";


const OccupancyHeatmap = ({ captureRateMealOcc, loading, mealPeriod }) => {
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const meals = mealPeriod;

  const getHeatmapClass = (value) => {
    if (value >= 90) return "heat-green";
    if (value >= 80) return "heat-yellow";
    if (value >= 70) return "heat-orange";
    return "heat-red";
  };

  const buildColorScale = (allValues, colors = [
    '#F8696B',  // Very Low (Red)
    '#FA8A72',  // Low
    '#FECB7E',  // Medium
    '#8AC97D',  // High
    '#63BE7B'   // Very High (Green)
  ]) => {
    const validValues = allValues.filter(v => v !== null && !isNaN(v));
    const min = Math.min(...validValues);
    const max = Math.max(...validValues);
    const steps = colors.length;

    // Prevent division by zero
    const range = Math.max(1, max - min);
    const stepSize = range / steps;

    return (val) => {
      if (val == null || isNaN(val)) return '#ccc';

      const index = Math.floor((val - min) / stepSize);

      // Clamp index within bounds
      const safeIndex = Math.max(0, Math.min(index, steps - 1));
      return colors[safeIndex];
    };
  };




  const occupancyValues = captureRateMealOcc
    .map(item => item.data[0])
    .filter(val => val !== null && val !== 0 && !isNaN(val));
  const captureRateValues = captureRateMealOcc.flatMap(item => item.data.slice(1)); // indexes 1-5

  const getOccupancyColor = buildColorScale(occupancyValues);
  const getCaptureRateColor = buildColorScale(captureRateValues);


  return (
    <Row>
      <Card>
        <CardHeader className="ps-0 border-0 align-items-center">
          <div className="d-flex align-items-start">
            <div className={`icon-box rounded bg-danger text-white`}>
              <i className="ri-pie-chart-fill"></i>
            </div>
            <div className="ps-2">
              <h4 className="card-title mb-0 flex-grow-1">Capture Ratio by Meal Period and Occupancy</h4>
              <p>Shows the percentage of occupied rooms that dined during each meal period</p>
            </div>
          </div>
        </CardHeader>
        <CardBody className="p-0">
          {loading && <Loader />}
          <div className={`table-responsive ${loading ? "opacity-0" : ""}`}>
            <table className="heatmap-table">
              <thead>
                <tr>
                  <th>Day</th>
                  <th className="text-center">OCC</th>
                  {meals.map((meal) => (
                    <th className="text-center" key={meal}>{meal}</th>
                  ))}
                </tr>
                <tr>
                  <td> </td>
                  <td className="text-center">Occupancy %</td>
                  {meals.map((meal) => (
                    <td className="text-center" key={meal + "_label"}>Capture %</td>
                  ))}
                </tr>
              </thead>
              {/* <tbody>
              {captureRateMealOcc && days.map((day) => {
                const dayData = captureRateMealOcc.find((item) => item.name === day);
                const values = dayData?.data || [];

                return (
                  <tr key={day}>
                    <td><b>{day}</b></td>
                    {[0, ...meals.map((_, idx) => idx + 1)].map((i, index) => {
                      const val = values[i] ?? null;
                      return (
                        <td className="text-center" key={day + "_val_" + index}>
                          {val !== null ? (
                            <span className={`heat-box ${getHeatmapClass(val)}`}>{val.toFixed(0)}%</span>
                          ) : (
                            <span className="text-muted">--</span>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody> */}
              <tbody>
                {captureRateMealOcc && days.map((day) => {
                  const dayData = captureRateMealOcc.find((item) => item.name === day);
                  const values = dayData?.data || [];

                  return (
                    <tr key={day}>
                      <td><b>{day}</b></td>
                      {[0, ...meals.map((_, idx) => idx + 1)].map((i, index) => {
                        const val = values[i] ?? null;
                        let bgColor = "#ccc";

                        if (val !== null) {
                          bgColor = i === 0
                            ? getOccupancyColor(val)       // For Occupancy
                            : getCaptureRateColor(val);    // For Capture Rates
                        }

                        return (
                          <td className="text-center" key={day + "_val_" + index}>
                            {val !== null && val > 0 ? (
                              <span className="heat-box" style={{ backgroundColor: bgColor }}>
                                {val.toFixed(2)}%
                              </span>
                            ) : (
                              <span className="text-muted">--</span>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>

            </table>
          </div>
        </CardBody>
      </Card>
    </Row>
  );
};

export default OccupancyHeatmap;
